module.exports = __webpack_public_path__ + "static/img/5318_phase_function_Paper_Points.4ff25bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5318_phase_function_Paper_Points.png
// module id = XX5H
// module chunks = 0